import Vue from 'vue';
import CInputLabel from '@/components/Helper/Form/CInputLabel.vue';
import CDatePicker from '@/components/Helper/Form/CDatePicker.vue';
import CBorderBtn from '@/components/Helper/Button/CBorderBtn.vue';

import VClamp from 'vue-clamp';

Vue.component('CheeersIcon', () => import('./Helper/CheeersIcon.vue'));
Vue.component('ApiSelect', () => import('./Helper/ApiSelect.vue'));
Vue.component('VClamp', VClamp);
Vue.component('CInputLabel', CInputLabel);
Vue.component('CDatePicker', CDatePicker);
Vue.component('CBorderBtn', CBorderBtn);
